import fs from 'node:fs';
import path from 'node:path';

const GIT_DIRECTORY = '.git';

function hasGitDirectory(dir: string): boolean {
  const gitPath = path.join(dir, GIT_DIRECTORY);

  // Check for a .git directory (not a file)
  return fs.existsSync(gitPath) && fs.statSync(gitPath).isDirectory();
}

function hasPnpmWorkspaces(dir: string): boolean {
  return fs.existsSync(path.join(dir, 'pnpm-workspace.yaml'));
}

/**
 * Find the root of the repository by looking for a `.git` directory. This should
 * work with submodules as well as it verifies that the `.git` directory is a
 * directory and not a file.
 *
 * TODO: support finding the root via other mechanisms to avoid the need for git to already be initialized
 */
export function findRepositoryRoot(startDir?: string): string {
  if (process.env.NX_WORKSPACE_ROOT) {
    // Trust NX's workspace root here so we don't have to rely on finding a .git
    // directory. There are some places (like the `vercel deploy` CLI command)
    // where the .git directory doesn't exist.
    // TODO: Figure out a way to find the repo root in non-NX `vercel deploy`s.
    return process.env.NX_WORKSPACE_ROOT;
  }

  let currentDir = startDir || process.cwd();

  while (currentDir !== path.parse(currentDir).root) {
    if (hasGitDirectory(currentDir) || hasPnpmWorkspaces(currentDir)) {
      return currentDir;
    }

    currentDir = path.dirname(currentDir);
  }

  throw new Error(
    'Repository root not found. Specify the root of the repository with the `repository.root` option.',
  );
}
